export const authConfig = {
  apiKey: process.env.REACT_APP_AUTH_API_KEY,
  appId: process.env.REACT_APP_AUTH_APP_ID,
  authDomain: process.env.REACT_APP_AUTH_AUTH_DOMAIN,
  messagingSenderId: process.env.REACT_APP_AUTH_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_AUTH_PROJECT_ID,
  storageBucket: process.env.REACT_APP_AUTH_STORAGE_BUCKET,
};

const firebaseConfig = {
  apiKey: process.env.REACT_APP_AUTH_API_KEY,
  appId: process.env.REACT_APP_MAIN_APP_ID,
  authDomain: process.env.REACT_APP_MAIN_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_MAIN_DATABASE_URL,
  messagingSenderId: process.env.REACT_APP_MAIN_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_MAIN_PROJECT_ID,
  storageBucket: process.env.REACT_APP_MAIN_STORAGE_BUCKET,
};


export default firebaseConfig;